import React from 'react'
import { Alert, Container } from 'react-bootstrap'
import { useRouteError } from 'react-router-dom'
import './style.scss'

const ErrorPage: React.FC = () => {
  const error: any = useRouteError()
  return (
    <Container>
      <Alert variant='danger'>
        <Alert.Heading>系統錯誤</Alert.Heading>
        <p>{error.statusText || error.message}</p>
      </Alert>
    </Container>
  )
}

export default ErrorPage
